module.exports = __webpack_public_path__ + "img/advertise_banner2.c45dd032.png";